import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/shared";

import { useLastEventValueByQuery } from "src/features/events";

export function useDateOfBirth(): string | undefined {
	const { formatDate } = useIntl();
	const value = useLastEventValueByQuery<string>(queries.dateOfBirth);
	return value === undefined
		? undefined
		: formatDate(value, {
				year: "numeric",
				month: "numeric",
				day: "numeric"
			});
}
